import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { checkChanges } from '../../utils/checkChanges';
import Overview from './Overview';

export default class Profile extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Overview = checkChanges(Overview)

  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child)
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Profile/Profile.jsx